import AgoraRTM from "agora-rtm-sdk";
import { createBrowserHistory } from "history";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

let history = createBrowserHistory();
let snackBarRef = null;

const saveSnackbarRef = (ref) => {
  snackBarRef = ref;
};

const showSnackBar = ({ message, vertical, horizontal, severity, style }) => {
  snackBarRef.setState({
    open: true,
    message: message || "success",
    vertical: vertical || "top",
    horizontal: horizontal || "center",
    severity: severity || "success",
    style,
  });
};

function camelCaseToTitle(text) {
  var result = text.replace(/([A-Z])/g, " $1");
  var finalResult = result.charAt(0).toUpperCase() + result.slice(1);
  return finalResult;
}

const numWithCommas = (num) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const AccountingFormat = (amount, currency = "") => {
  if (amount < 0)
    return `${currency}(${numWithCommas(
      Number(Math.abs(amount)).toFixed(2).replace("-", ""),
    )})`;
  else
    return `${currency}${numWithCommas(
      Number(amount).toFixed(2).replace("-", ""),
    )}`;
};

const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();

    return <Component navigate={navigate} {...props} />;
  };

  return Wrapper;
};

const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+=[\]{};':",./<>?])(?=.{8,})\S+$/;

export const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

const sendEndStreamMessage = async ({
  channelName,
  rtmToken,
  agoraAppId,
  uid = null,
}) => {
  let rtmClient = null;
  let channel = null;

  try {
    console.log("[RTM] Starting end stream message with params:", {
      channelName,
      uid,
      rtmToken,
      agoraAppId: agoraAppId.substring(0, 8) + "...",
    });

    if (!channelName || !rtmToken || !agoraAppId) {
      return {
        success: false,
        error:
          "Missing required parameters: channelName, rtmToken, or agoraAppId",
      };
    }

    // Create RTM client
    rtmClient = AgoraRTM.createInstance(agoraAppId);

    console.log("[RTM] RTM client created");

    // Login with RTM token - uid MUST match the uid used to generate the token
    await rtmClient.login({
      uid: uid,
      token: rtmToken,
    });

    console.log("[RTM] Successfully logged in with uid:", uid);

    // Join RTM channel
    channel = rtmClient.createChannel(channelName);
    await channel.join();

    console.log("[RTM] Successfully joined channel:", channelName);

    // Send "END_STREAM" message to notify all viewers
    await channel.sendMessage({ text: "End Stream" });

    console.log("[RTM] End stream message sent successfully");

    // Cleanup RTM connection
    await channel.leave();
    await rtmClient.logout();

    console.log("[RTM] Cleanup completed");

    return { success: true };
  } catch (error) {
    console.error("[RTM] Full error object:", error);
    const errorMessage = error instanceof Error ? error.message : String(error);
    console.error("[RTM] Error details:", {
      message: errorMessage,
      name: error instanceof Error ? error.name : "Unknown",
      code: error,
    });

    // Try to cleanup on error
    try {
      if (channel) {
        await channel.leave().catch(() => {});
      }
      if (rtmClient) {
        await rtmClient.logout().catch(() => {});
      }
    } catch (cleanupError) {
      console.error("[RTM] Cleanup error:", cleanupError);
    }

    return {
      success: false,
      error: errorMessage,
    };
  }
};

export default {
  history,
  snackBarRef,
  withRouter,
  saveSnackbarRef,
  showSnackBar,
  emailRegex,
  passwordRegex,
  camelCaseToTitle,
  AccountingFormat,
  sendEndStreamMessage,
};
